<template>
  <div :class="$loading ? 'pull-left read-only' : 'pull-left'">
    <div
      class="selector-wrapper w-100"
      :class="{
        selected: hidePlaceholder == false,
        'not-selected': hidePlaceholder == true,
        'read-only': $loading,
      }"
    >
      <div class="w-100" :class="{ 'opacity-mid': hidePlaceholder }">
        <div v-if="type != 'salesperson'" @click="openDropdown">
          <span v-text="getValue"></span>
          <font-awesome-icon
            :icon="isHidden ? ['fas', 'angle-down'] : ['fas', 'angle-up']"
            class="float-right mt-1"
          />
        </div>

        <div
          v-if="
            type == 'salesperson' &&
              isHidden &&
              currentValue == 'Select Salesperson' &&
              this.getValue == 'Select Salesperson'
          "
          @click="openDropdown"
        >
          <span v-text="getValue"></span>
          <font-awesome-icon
            :icon="['fas', 'angle-down']"
            class="float-right mt-1"
          />
        </div>

        <div
          v-if="
            type == 'salesperson' &&
              isHidden &&
              getValue != 'Select Salesperson'
          "
          @click="$emit('remove-salesman')"
        >
          <span v-text="getValue"></span>
          <font-awesome-icon
            :icon="['fas', 'times']"
            class="float-right mt-1"
          />
        </div>
        <div v-if="type == 'salesperson' && !isHidden" @click="openDropdown">
          <span v-text="getValue"></span>
          <font-awesome-icon
            :icon="['fas', 'angle-up']"
            class="float-right mt-1"
          />
        </div>
      </div>
      <transition name="fade">
        <div class="dropdown-body w-100" v-if="isHidden == false">
          <div
            class="search-block fs-11"
            v-if="searchable"
            :class="{ focused: onEdit == true }"
          >
            <input
              type="text"
              placeholder="Search..."
              ref="search"
              v-model="search"
              @input="filterData"
            />
            <font-awesome-icon :icon="['fas', 'search']" />
          </div>
          <ul class="m-0 filter-dropdown list-unstyled">
            <li
              v-for="(item, i) in getOptions"
              :key="i"
              :class="item.value == getValue ? 'current-selection' : null"
              @click="selectCurrentStore(item)"
            >
              <span v-text="item.value"></span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: "custom-dropdown",
  data() {
    return {
      isHidden: true,
      hidePlaceholder: true,
      selectedStore: "",
      onEdit: false,
      getValue: "",
      getOptions: [],
      search: "",
    };
  },
  watch: {
    search() {
      if (this.search == "") this.getOptions = this.options;
    },
    currentValue() {
      if (this.type == "salesperson") {
        this.setSalesPersonData();
      }
    },
  },
  props: ["options", "type", "currentValue", "searchable"],
  computed: {},
  created() {
    if (this.type == "salesperson") {
      this.setSalesPersonData();
    } else {
      this.getValue = this.currentValue;
    }
    this.getOptions = this.options;
    window.addEventListener("keydown", (e) => {
      if (e.code == "Escape") this.isHidden = true;
    });
  },
  methods: {
    setSalesPersonData() {
      let salesp = [];
      salesp = this.options.filter((element) => {
        if (element.id == this.currentValue) {
          return element;
        }
      });
      if (salesp.length > 0) {
        this.getValue = salesp[0].value;
        this.hidePlaceholder = false;
      } else {
        this.getValue = this.currentValue;
      }
    },
    openDropdown() {
      if (this.$loading) return;
      this.isHidden = !this.isHidden;
    },
    selectCurrentStore(data) {
      this.selectedStore = data.value;
      this.getValue = data.value;
      if (this.placeHolderText !== "") {
        this.hidePlaceholder = false;
      }
      console.log(data.value);
      this.$emit("update-value", data);
      this.isHidden = true;
      this.search = "";
    },
    filterData() {
      this.getOptions = [];
      let search_term = new RegExp(this.search.toLowerCase());
      this.getOptions = this.options.filter((item) => {
        if (search_term.test(item.value.toLowerCase())) return item;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.selector-wrapper {
  padding: 13px 13px;
  position: relative;
  background: $body-color-light;
  border-radius: 5px;
}

.selector-wrapper:hover {
  cursor: pointer;
}
// .selector-wrapper.not-selected .default-name{display:none;}
.selector-wrapper .default-name {
  color: $dark-card-text;
}
// .selector-wrapper.selected .default-name {
//   display: none;
// }
// .selector-wrapper.not-selected .store-name {
//   display: none;
// }
.selector-wrapper .dropdown-body {
  margin-top: 5px;
  position: absolute;
  top: 35px;
  left: 0;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  border: 1px solid $dark-card-title-header;
  z-index: 999;
  border-radius: 4px;
  background: $white-color;
  @include custom-scrollbar();
  max-height: 180px;
  overflow-y: auto;
}
.selector-wrapper .filter-dropdown li {
  color: grey;
  padding: 7px 15px;
  position: relative;
}
.promo-list .selector-wrapper .filter-dropdown li:hover {
  background: transparent;
}
.selector-wrapper .filter-dropdown li:hover {
  background: $body-color-light;
}
promo-list
.selector-wrapper .filter-dropdown li.current-selection {
  color: black;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.search-block {
  background: $body-color-light;
  border-radius: 4px;
  padding-left: 3px;
  margin: 7px 7px 3px 7px;
  height: 30px;
  border: 1px solid transparent;
  input {
    height: 28px;
    width: 90%;
    &:focus {
      border: 1px solid transparent !important;
    }
  }
  .fa-search {
    color: $dark-card-text;
  }
  &:focus {
    border: 1px solid $p-color;
    .fa-search {
      color: $body-color;
    }
  }
}
.read-only {
  cursor: no-drop;
}
.opacity-mid {
  opacity: 0.5;
}
.theme-dark {
  .search-block {
    background: #303030;
    input {
      &:focus {
        background: #303030 !important;
      }
    }
  }
  .selector-wrapper {
    background: #303030;
    color: $white-color;
    .dropdown-body {
      background: #101010;
      border: 1px solid #606060;
    }
    .filter-dropdown {
      li {
        &.current-selection {
          color: $white-color;
        }
        // &:hover {
        //   &.current-selection {
        //   }
        // }
      }
    }
  }
}
</style>
